import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/unstake/unstake-information.module.scss';
import Header from '../../../../../../../components/Stake/header';
import OmIcon from '../../../../../../../assets/images/tokens/om.svg';
import * as omStakeActions from '../../../../../../../actions/om-stake-actions';
import { useGetTheme } from '../../../../../../../hooks/useGetTheme';

const UnstakeInformation = () => {
  const dispatch = useDispatch();
  const colors = useGetTheme();

  return (
    <>
      <Header
        icon={OmIcon}
        title='OM-Unstaking'
        onClickBack={() => dispatch(omStakeActions.unstakeSettings())}
      />
      <div className={stylesParent.cardContent} style={{ color: colors.text }}>
        <div className={styles.title}>Withdrawal Timer Reset!</div>
        <div className={styles.description}>
          <span>IMPORTANT:</span> If you are currently unstaking and decide to unstake more tokens
          half way through, the timer will be reset to 8-days, and you will be able to withdraw both
          set of tokens after 8-days.
        </div>
        <div className={stylesParent.cardFooterControls}>
          <Button
            onClick={() => dispatch(omStakeActions.unstakeDetails())}
            variant='contained'
            color='secondary'
            className={stylesParent.cardFooterControlsButton}
          >
            Continue
          </Button>
        </div>
      </div>
    </>
  );
};

export default UnstakeInformation;
